import React from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
// import { Image } from "react-bootstrap";
import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";
import { TopTextReusableComponent } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { ReusableOnboardingButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import GeoLocation from "./GeoLoaction";
import axios from "axios";
import { withRouter } from "react-router-dom";

const SuperAdminAddMapDetails = (props) => {
  const onClickHandler = (condition) => async (e) => {
    let location = {};
    if (condition === "yes") {
      location = await GeoLocation(window.navigator);
    } else {
      try {
        let result = await axios.get("https://ipapi.co/json");
        location = {
          lat: result.data.latitude,
          lng: result.data.longitude,
        };
      } catch (err) {
        location = {
          lat: 18.67,
          lng: 29.67,
        };
      }
    }
    props.history.push({
      pathname: "/addvendormapdetailslocation",
      state: { location: location, actionButton: true },
    });
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="col-12 pl-5 pr-5">
              <div className="super_admin_add_vendor mb-4">
                <h5 className="main_header_text">Add Vendor</h5>
                <h4 className="font_20_m">Step : 1</h4>
                <h4 className="font_20_m c_red mt-2 mb-1">Map Setup</h4>
                <hr className="hr_line" />
              </div>
              <TopTextReusableComponent
                headingText="Map Setup"
                headingParagraph="Enter the details about your Business location"
              />
              <div className="onboarding-process-map-setup-bodyBox">
                <div className="display-toggle-stepup-button">
                  <RightSidePannel selectedTab={1} />
                </div>
                <h3 className="mt-5 mb-5 font_24_b">
                  Are you present on Google Maps?
                </h3>
                <div className="onboarding-process-map-setup-buttonBox d-flex">
                  <ReusableOnboardingButton
                    buttonType="button"
                    buttonTitle="No Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="No"
                    onClick={onClickHandler("no")}
                  />
                  <ReusableOnboardingButton
                    buttonType="button"
                    buttonTitle="Yes Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                    buttonText="Yes"
                    onClick={onClickHandler("yes")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(SuperAdminAddMapDetails);
